import { CoCotizaciondetalle } from './../../../comercial/cotizacion/dominio/CoCotizaciondetalle';
import { CoAutorizacionDescuentoDetalleService } from './../../../comercial/coautorizaciondescuentodetalle/servicio/coautorizaciondescuentodetalle.servicio';
import { CoCotizacionServicio } from 'src/app/erp/comercial/cotizacion/servicio/cotizacion.service';
import { CoCotizacion } from './../../../comercial/cotizacion/dominio/CoCotizacion';
import { WhItemMastServicio } from './../servicio/WhItemMast.service';
import { CoDocumentoServicio } from './../../../comercial/codocumento/service/codocumento.service';
import { CoDocumento } from './../../../comercial/codocumento/dominio/CoDocumento';
import { PrincipalBaseComponent } from './../../../../util/PrincipalBaseComponent';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { DtoWhItemList } from '../dominio/DtoWhItemList';

@Component({
    selector: 'app-item-nuevo-detalle',
    templateUrl: './whitemmast-detalle-nuevo.component.html'
})
export class WhItemDetalleNuevoComponent extends PrincipalBaseComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
        private router: Router,
        private coCotizacionServicio: CoCotizacionServicio,
        private whItemMastServicio: WhItemMastServicio,
        private coDocumentoServicio: CoDocumentoServicio,
    ) { super(noAuthorizationInterceptor, messageService); }

    item: DtoWhItemList = new DtoWhItemList();
    documento: CoDocumento = new CoDocumento();
    cotizacion: CoCotizacion = new CoCotizacion();
    origen: string = '';
    verdescuentos: string;
    acction: string;
    claveAutorizacion: number;
    habilitarDescuento: Boolean = true;
    verModal: Boolean = false;
    //verModalDescuento: Boolean = false;

    ngOnInit(): void {
    }

    @Output() alCerrar = new EventEmitter();

    iniciarModal(acction: string, origen: string, verdescuentos: string, bean: any, dto: any) {
        this.bloquearPagina()
        this.verModal = true;
        this.acction = acction;
        this.origen = origen;
        this.verdescuentos = verdescuentos;
        if (this.acction === 'NUEVO') {
            this.nuevo(dto,
                bean);
        } else if (this.acction === 'EDITAR') {
            this.editar(dto,
                bean);
        }
    }

    setFocus(elm: HTMLInputElement) {
        setTimeout(() => {
          elm.focus()
        }, 50);
      }

    nuevo(item: DtoWhItemList, bean: any) {
        this.whItemMastServicio.obtenerItem(item.item).then(
            resp => {
                this.desbloquearPagina();
                this.item = resp;

                if (this.origen === 'PEDIDO') {
                    this.documento = bean;
                    this.documento.item = this.item.item;
                } else if (this.origen === 'COTIZACION') {
                    this.cotizacion = bean;
                    this.cotizacion.item = this.item.item;
                }

            }
        );
    }

    obtenerAutorizacion() {
        if (this.documento.claveAutorizacion === undefined || this.documento.claveAutorizacion === null) {
            this.mostrarMensajeAdvertencia('Por favor ingresar la contraseña para la autorizacion');
            return;
        }

        this.coDocumentoServicio.obtenerAutorizacionDescuento04(this.documento).then(
            resp => {
                if (resp !== null) {
                    this.documento = resp;
                    if (resp.descuento04flag === 'S') {
                        this.habilitarDescuento = false;
                        this.item.porcentajedescuento04 = resp.descuento04;
                    }
                }
            }
        ).catch(error => {
            this.mostrarMensajeAdvertencia(error);
            this.desbloquearPagina();
        });
    }

    editar(item: DtoWhItemList, bean: any) {
        this.desbloquearPagina();
        this.item = item;
        if (this.origen === 'PEDIDO') {
            this.documento = bean;
            if (item.descuento04flag === 'S') {
                this.habilitarDescuento = false;
            } else {
                this.habilitarDescuento = true;
            }
            this.documento.item = this.item.item;
        } else if (this.origen === 'COTIZACION') {
            this.cotizacion = bean;
            if (item.descuento04flag === 'S') {
                this.habilitarDescuento = false;
            } else {
                this.habilitarDescuento = true;
            }
            this.cotizacion.item = this.item.item;
        }
    }

    validar(): Boolean {
        let valida: Boolean = false;
        if (this.item.cantidad === undefined || this.item.cantidad === null || this.item.cantidad === 0) {
            this.mostrarMensajeAdvertencia('Ingrese valor en la cantidad ');
            valida = true;
        }

        if (!this.habilitarDescuento) {
            if (this.item.porcentajedescuento04 > this.item.porcentajedescuento04_Valid) {
                this.mostrarMensajeAdvertencia('El % #4 ingresado excede al máximo permitido x Item ' + this.documento.descuento04);
                valida = true;
            }
        }

        if (this.item.porcentajedescuento02_Valid === null || this.item.porcentajedescuento02_Valid === undefined) {
            this.item.porcentajedescuento02_Valid = 0;
        }
        if (this.item.porcentajedescuento02 > this.item.porcentajedescuento02_Valid) {
            this.mostrarMensajeAdvertencia('El % #2 ingresado excede al máximo permitido x Item ' + this.item.porcentajedescuento02_Valid);
            valida = true;
        }

        if (this.item.porcentajedescuento03_Valid === null || this.item.porcentajedescuento03_Valid === undefined) {
            this.item.porcentajedescuento03_Valid = 0;
        }
        if (this.item.porcentajedescuento03 > this.item.porcentajedescuento03_Valid) {
            this.mostrarMensajeAdvertencia('El % #3 ingresado excede al máximo permitido x Item ' + this.item.porcentajedescuento03_Valid);
            valida = true;
        }

        return valida;
    }

    agregar() {

        if (this.validar()) {
            return;
        }

        if (this.item.cantidad === undefined || this.item.cantidad === null) {
            this.mostrarMensajeAdvertencia('Por favor ingresar la cantidad');
            return;
        }

        if (this.origen === 'PEDIDO') {
            this.bloquearPagina();
            this.documento.cantidad = this.item.cantidad;

            if (this.acction === 'NUEVO') {
                this.documento.iv_action = 'Add';
                this.coDocumentoServicio.registrarPedido(this.documento).then(
                    resp => {
                        this.documento = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.documento.item + ' se ha agregado Correctamente');
                        this.verModal = false;
                        this.alCerrar.emit(resp);
                    }
                );
            } else if (this.acction === 'EDITAR' && this.verdescuentos === 'N') {
                this.documento.iv_action = 'Add';
                this.coDocumentoServicio.registrarPedido(this.documento).then(
                    resp => {
                        this.documento = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.documento.item + ' se ha agregado Correctamente');
                        this.verModal = false;
                        this.alCerrar.emit(resp);
                    }
                );
            } else if (this.acction === 'EDITAR' && this.verdescuentos === 'S') {
                this.documento.cantidadItem = this.item.cantidad;
                this.documento.descuento01 = this.item.porcentajedescuento01;
                this.documento.descuento02 = this.item.porcentajedescuento02;
                this.documento.descuento03 = this.item.porcentajedescuento03;
                this.documento.descuento04 = this.item.porcentajedescuento04;
                this.documento.iv_action = 'U';
                this.whItemMastServicio.calcularMontos(this.documento).then(
                    resp => {
                        this.documento = resp;
                        this.desbloquearPagina();
                        this.mostrarMensajeExito('El Item N°' + this.documento.item + ' se ha actualizado Correctamente');
                        this.verModal = false;
                        this.alCerrar.emit(resp);
                    }
                );

            }

        } else if (this.origen === 'COTIZACION') {
            this.bloquearPagina();
            this.cotizacion.cantidad = this.item.cantidad;

            if (this.acction === 'NUEVO') {
                this.cotizacion.iv_action = 'Add';
                this.coCotizacionServicio.registrarDetalle(this.cotizacion).then(
                    resp => {
                        if (resp != null) {
                            this.cotizacion = resp;
                            this.mostrarMensajeExito('El Item N°' + this.cotizacion.item + ' se ha agregado Correctamente');
                            this.verModal = false;
                            this.alCerrar.emit(resp);
                        }
                        this.desbloquearPagina();
                    }
                );
            } else if (this.acction === 'EDITAR' && this.verdescuentos === 'N') {
                this.cotizacion.iv_action = 'Add';
                this.coCotizacionServicio.registrarDetalle(this.cotizacion).then(
                    resp => {
                        if (resp != null) {
                            this.cotizacion = resp;
                            this.mostrarMensajeExito('El Item N°' + this.cotizacion.item + ' se ha agregado Correctamente');
                            this.verModal = false;
                            this.alCerrar.emit(resp);
                        }
                        this.desbloquearPagina();
                    }
                );
            } else if (this.acction === 'EDITAR' && this.verdescuentos === 'S') {
                this.cotizacion.cantidadItem = this.item.cantidad;
                this.cotizacion.descuento01 = this.item.porcentajedescuento01;
                this.cotizacion.descuento02 = this.item.porcentajedescuento02;
                this.cotizacion.descuento03 = this.item.porcentajedescuento03;
                this.cotizacion.descuento04 = this.item.porcentajedescuento04;
                this.cotizacion.iv_action = 'U';
                this.whItemMastServicio.calcularMontosCotizacion(this.cotizacion).then(
                    resp => {
                        if (resp != null) {
                            this.cotizacion = resp;
                            this.mostrarMensajeExito('El Item N°' + this.cotizacion.item + ' se ha actualizado Correctamente');
                            this.verModal = false;
                            this.alCerrar.emit(resp);
                        }
                        this.desbloquearPagina();
                    }
                );

            }
        }
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.agregar();
        }
    }

    calcularMontosEditar() {
        if (this.validar()) {
            return;
        }
        if (this.origen === 'PEDIDO') {

            this.documento.cantidadItem = this.item.cantidad;
            this.documento.descuento01 = this.item.porcentajedescuento01;
            this.documento.descuento02 = this.item.porcentajedescuento02;
            this.documento.descuento03 = this.item.porcentajedescuento03;
            this.documento.descuento04 = this.item.porcentajedescuento04;
            this.documento.iv_action = 'U';
            this.whItemMastServicio.calcularMontos(this.documento).then(
                resp => {
                    this.documento = resp;
                }
            );
        } else if (this.origen === 'COTIZACION') {
            this.cotizacion.cantidadItem = this.item.cantidad;
            this.cotizacion.descuento01 = this.item.porcentajedescuento01;
            this.cotizacion.descuento02 = this.item.porcentajedescuento02;
            this.cotizacion.descuento03 = this.item.porcentajedescuento03;
            this.cotizacion.descuento04 = this.item.porcentajedescuento04;
            this.cotizacion.iv_action = 'U';
            this.whItemMastServicio.calcularMontosCotizacion(this.cotizacion).then(
                resp => {
                    if (resp !== null) {
                        this.cotizacion = resp;
                    }
                }
            );
        }
    }
}
